<template>
  <div class="wrapper">
    <div class="bg-page" :style="bgPage"></div>
    <div class="panel">
      <div class="body-panel-login">
        <b-form>
          <img
            class="img-fluid mx-auto d-block"
            src="@/assets/logo-indecx.png"
            alt=""
          />
          <p class="recover-password">
            {{ $t('changePassword.form.description') }}
          </p>
          <!-- <p v-if="email">
            {{ $t('changePassword.form.strongPassMessage') }}
          </p> -->
          <b-form-group>
            <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
              <b-input-group-text slot="prepend">
                <i class="fas fa-key"></i>
              </b-input-group-text>
              <b-input
                id="pass"
                v-model="form.password"
                type="password"
                @input="checkPassword"
                required
                :placeholder="$t('changePassword.form.newPasswordInput')"
                autofocus
              ></b-input>
            </b-input-group>
            <ul>
              <span class="invalid-feedback">
                <li>
                  {{ $t('menu.settings.users.invalidFeedbackSamePass') }}
                </li>
              </span>
              <span v-if="!contains_eight_characters">
                <li class="invalid-password-user">
                  {{ $t('menu.settings.users.messages.eightCharacters') }}
                </li></span
              >
              <span v-if="!contains_number"
                ><li class="invalid-password-user">
                  {{ $t('menu.settings.users.messages.containNumbers') }}
                </li>
              </span>
              <span v-if="!contains_uppercase"
                ><li class="invalid-password-user">
                  {{ $t('menu.settings.users.messages.containCapitalLetters') }}
                </li>
              </span>
              <span v-if="!contains_special_character">
                <li class="invalid-password-user">
                  {{
                    $t('menu.settings.users.messages.containSpecialCharacters')
                  }}
                </li>
              </span>
            </ul>
          </b-form-group>

          <b-form-group>
            <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
              <b-input-group-text slot="prepend">
                <i class="fas fa-key"></i>
              </b-input-group-text>
              <b-input
                id="cpass"
                v-model="form.cpassword"
                type="password"
                required
                :placeholder="
                  $t('changePassword.form.passwordConfirmationInput')
                "
              ></b-input>
            </b-input-group>
          </b-form-group>

          <b-form-group>
            <b-button
              type="button"
              @click="validateData()"
              class="btn-block"
              variant="primary"
              :disabled="loading"
              >{{ $t('changePassword.form.submitButton') }}</b-button
            >
          </b-form-group>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert';
import api from '../../../../services/api';
import backgroundImage1 from '../../../../assets/1.png';
import backgroundImage2 from '../../../../assets/2.png';
import backgroundImage3 from '../../../../assets/3.png';
import backgroundImage4 from '../../../../assets/4.png';
import backgroundImage5 from '../../../../assets/5.png';
import backgroundImage6 from '../../../../assets/6.png';
import backgroundImage7 from '../../../../assets/7.png';

export default {
  name: 'ForgotPassword',

  data: () => ({
    show: true,
    loading: false,
    form: {
      password: null,
      cpassword: null,
    },
    bgPage: {
      background: null,
      backgroundRepeat: null,
      backgroundSize: null,
      backgroundPosition: null,
    },
    contains_eight_characters: true,
    contains_number: true,
    contains_uppercase: true,
    contains_special_character: true,
    valid_password: true,
    code: null,
    // email: null,
  }),

  methods: {
    async validateData() {
      this.loading = true;

      if (!this.form.password || !this.form.cpassword) {
        this.makeToast(
          this.$t('changePassword.tooltips.emptyFieldValidation.description'),
          this.$t('changePassword.tooltips.emptyFieldValidation.title'),
        );
      } else if (this.form.password !== this.form.cpassword) {
        this.makeToast(
          this.$t('changePassword.tooltips.passwordValidation.description'),
          this.$t('changePassword.tooltips.passwordValidation.title'),
        );
      } else if (!this.valid_password) {
        this.makeToast(
          this.$t(
            'changePassword.tooltips.strongPasswordValidation.description',
          ),
          this.$t('changePassword.tooltips.strongPasswordValidation.title'),
        );
      } else {
        try {
          await api.post(`/change-password`, {
            password: this.form.password,
            code: this.code,
            // email: this.email,
          });

          swal({
            title: this.$t('changePassword.alerts.success.title'),
            text: this.$t('changePassword.alerts.success.description'),
            icon: 'success',
          });

          this.$router.push('/');
        } catch (error) {
          this.makeToast(
            this.$t('changePassword.alerts.failure.description'),
            this.$t('changePassword.alerts.failure.title'),
          );
        }
      }

      this.loading = false;
    },

    makeToast(message, title, variant = 'danger') {
      this.toastCount += 1;
      this.$bvToast.toast(`${message}`, {
        title,
        autoHideDelay: 5000,
        appendToast: false,
        variant,
      });
    },
    checkPassword() {
      this.password_length = this.form.password.length;

      const format = /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;

      if (this.password_length > 8) {
        this.contains_eight_characters = true;
      } else {
        this.contains_eight_characters = false;
      }

      this.contains_number = /\d/.test(this.form.password);
      this.contains_uppercase = /[A-Z]/.test(this.form.password);
      this.contains_special_character = format.test(this.form.password);

      if (
        this.contains_eight_characters === true &&
        this.contains_special_character === true &&
        this.contains_uppercase === true &&
        this.contains_number === true
      ) {
        this.valid_password = true;
      } else {
        this.valid_password = false;
      }
    },
  },

  mounted() {
    const imgs = [
      backgroundImage1,
      backgroundImage2,
      backgroundImage3,
      backgroundImage4,
      backgroundImage5,
      backgroundImage6,
      backgroundImage7,
    ];
    this.bgPage.background = `url('${imgs[Math.floor(Math.random() * 7)]}')`;
    this.bgPage.minHeight = '100vh';
    this.bgPage.minWidth = '100vw';
    this.bgPage.backgroundRepeat = 'no-repeat';
    this.bgPage.backgroundSize = 'cover';
    this.bgPage.backgroundAttachment = 'fixed';
    this.bgPage.backgroundPosition = 'center';
    this.code = this.$route.query.code;
    // this.email = atob(this.$route.query.email);
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
@import '@/themes/default/placeholders.scss';
@import '@/themes/default/mixins.scss';
.recover-password {
  text-align: center;
  font-size: 0.9em;
}

// .recover-password {
//   display: block;
//   text-align: center;
// }

.wrapper {
  @extend %center;
  // @include bg-color($secondary);
  .bg-page {
    // background: url('../../../../assets/images/desk-equipment-eyeglasses-876467.jpg');
    // background-repeat: no-repeat;
    // background-size: cover;
    // background-position: center;
    width: auto;
    height: auto;
    min-width: 100%;
    min-height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    transform: scale(1);
    opacity: 0.6;
    z-index: -1;
    transition: all 0.2s linear;
    animation: zoomOut 0.4s;
  }

  @keyframes zoomOut {
    from {
      transform: scale(1.3);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 0.6;
    }
  }

  .panel {
    width: 90%;
    max-width: 420px;

    border-radius: 5px;
    display: flex;
    flex-direction: column;
    @include bg-color(rgba(255, 255, 255, 0.8));
    @media screen and (min-width: 576px) {
      width: 100%;
    }

    .body-panel-login {
      // @include bg-color($white);
      @extend %double-padding-left,
        %double-padding-right,
        %double-padding-top,
        %double-padding-bottom;

      form {
        @extend %double-padding-top, %double-padding-bottom;
        .img-fluid {
          width: 50%;
          margin-bottom: 30px;
        }
        .input-group-text {
          border: none;
          @include bg-color($white);
          border-top-left-radius: 30px;
          border-bottom-left-radius: 30px;
          color: $secondary;
          border: 1px solid $gray-lighter;
          border-right: none;
        }
        .form-control {
          box-shadow: none;
          border: none;
          border-top-right-radius: 30px;
          border-bottom-right-radius: 30px;
          @include bg-color($white);
          text-indent: 0;
          padding: 0;
          color: $secondary;
          border: 1px solid $gray-lighter;
          border-left: none;
        }
      }
      button {
        border-radius: 30px;
      }
    }
  }
}
.invalid-password-user {
  font-size: 80%;
  color: #d50000;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/home/forgot-password/change-password.vue